export default {
  testimonials: 'Testimonios',
  institutions: 'Instituciones',
  subtitle: 'Instituciones que lideran la transformación digital de la educación superior junto a KeyLearning.',
  location: 'Dónde encontrarnos',
}
